import n from "axios";
import * as p from "@sentry/react";
const i = (r) => {
  const a = n.create({
    baseURL: "https://staging.minohealth.ai:3003/anokye",
    headers: {
      Authorization: `Bearer ${r}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
  function m(e) {
    return Promise.reject(e);
  }
  return a.interceptors.response.use((e) => e, m), a.interceptors.request.use((e) => (p.addBreadcrumb({
    category: "http",
    type: "http",
    level: "info",
    message: `${e.method?.toUpperCase()} ${e.url} (Anokye API)`,
    data: {
      url: e.url,
      method: e.method,
      baseURL: e.baseURL,
      params: e.params
    }
  }), e)), a.interceptors.response.use(
    (e) => (p.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${e.config.method?.toUpperCase()} ${e.config.url} (Anokye API) - ${e.status}`,
      data: {
        url: e.config.url,
        method: e.config.method,
        status: e.status
      }
    }), e),
    (e) => {
      const t = e.response?.status, s = e.config?.url, o = e.config?.method;
      return p.addBreadcrumb({
        category: "http",
        type: "error",
        level: "error",
        message: `${o?.toUpperCase()} ${s} (Anokye API) - ${t || "Network Error"}`,
        data: {
          url: s,
          method: o,
          status: t,
          errorMessage: e.message,
          responseData: e.response?.data
        }
      }), p.captureException(e, {
        tags: {
          api_service: "anokye",
          api_endpoint: s,
          http_method: o,
          http_status: t
        },
        contexts: {
          response: {
            status: t,
            data: e.response?.data
          },
          request: {
            url: s,
            method: o,
            params: e.config?.params
          }
        }
      }), Promise.reject(e);
    }
  ), {
    GetParticipants: (e) => a.get("/participants", { params: e }),
    GetResources: (e) => a.get("/resource", { params: e }),
    GetReviews: (e) => a.get("/review", { params: e }),
    GetRankedReviewers: (e) => a.get("/reviewer", { params: e }),
    PostReview: (e) => a.post("/review", e),
    SaveDraft: (e) => a.post("/draft", e),
    AcceptReviews: (e) => a.post("/accept", e),
    PostShareResource: (e) => a.post("/share", e),
    GetReportById: (e) => a.get("/resource", { params: e }),
    PostNewComment: (e, t) => a.post("/comment", e, {
      params: { commentType: "newComment" },
      ...t
    }),
    GetSingleComment: (e, t) => a.get("/comment", {
      params: { commentType: "singleComment", commentId: e },
      ...t
    }),
    GetAllComments: (e, t) => a.get("/comment", {
      params: { commentType: "allComments", reportId: e },
      ...t
    }),
    GetReviewerTotalPayout: (e, t) => a.get("/payout", {
      params: { CashOutType: "totals", userId: e },
      ...t
    }),
    GetReviewerDueStatements: (e, t) => a.get("/payout", {
      params: { CashOutType: "dueStatements", userId: e },
      ...t
    }),
    GetReviewerPaidStatements: (e, t) => a.get("/payout", {
      params: { CashOutType: "paidStatements", userId: e },
      ...t
    }),
    PostPacsUpload: (e, t) => a.post("/pacs", e, {
      params: { pacsType: "newUpload" },
      ...t
    }),
    GetStudies: (e, t) => a.get("/pacs", {
      params: { pacsType: "allStudies", ...e },
      ...t
    }),
    GetStudy: (e, t) => a.get("/pacs", {
      params: { pacsType: "getStudy", ...e },
      ...t
    }),
    PostPacsDicomViewUrl: (e, t) => a.post("/pacs", e, {
      params: { pacsType: "dicomViewUrl" },
      ...t
    })
  };
}, u = "message:timeout";
export {
  u as SESSION_TIMEOUT_EVENT,
  i as default
};
